import { OutlinedInput } from "@mui/material";
import { useEffect, useState } from "react";
import { TableColumn } from "react-data-table-component";
import { shallowEqual, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { RootState } from "../../../../redux";
import Table from "../../../../ui/components/table/table";
import { UserInfo } from "../../../../ui/models/userInfo";
import { PrecargaSempreList } from "../../../models/precarga-sempre-list";
import { importacionSempreServices } from "../../../services/importacion-sempre.services";
import { getFormattedDate, getFormattedDecimal } from "../../../utils/common.utils";
import {
  initialFilter,
  queryParamsConfig,
} from "../../../utils/precarga-sempre.utils";
import { useQueryParamsReplace } from "../../../utils/useQueryParamsReplace";
import "./precarga-sempre-admin.scss";
import AutocompleteSelect from "../../../../ui/components/autocomplete-select/autocomplete-select";
import { ListModel } from "../../../models/list-model";
import { profesionalServices } from "../../../services/profesional.services";
import { initialProfesionalFilter } from "../../../utils/profesional.utils";

export default function PrecargaSempreAdmin() {
  const [queryParams, setQueryParams] =
    useQueryParamsReplace(queryParamsConfig);
  const [fetching, setFetching] = useState<boolean>(true);
  const location = useLocation();
  const [queryParamsProfesional, setQueryParamsProfesional] = useState<any>();
  const [profesionalIdSelected, setProfesionalIdSelected] = useState<string>();
  const [profesionales, setProfesionales] = useState<ListModel[]>([]);
  const [entities, setEntities] = useState<PrecargaSempreList[]>([]);
  const [totalCount, setTotalCount] = useState<number>(0);

  const columns: TableColumn<PrecargaSempreList>[] = [
    {
      name: "Profesional",
      selector: (row: any) => row.efectorNombre,
      sortable: true,
      sortField: "efectornombre",
    },
    {
      name: "Paciente",
      selector: (row) => row.afiliadoCuil + " - " + row.afiliadoNombre,
      sortable: true,
      sortField: "paciente",
      width: "20%",
    },
    {
      name: "Nro. Validación Online",
      selector: (row) => row.valOnlineNumero,
      sortable: true,
      sortField: "valonlinenumero",
      width: "8%",
    },
    {
      name: "Serie Número",
      selector: (row) =>
        ArmarSerieNumero(row.serieNumero, row.prescripcionNumero),
      sortable: true,
      sortField: "serienumero",
      width: "7%",
    },
    {
      name: "Código de Práctica",
      selector: (row) => row.codigoPractica,
      wrap: true,
      width: "7%",
    },
    {
      name: "Descripcion",
      selector: (row) => row.nombrePractica,
    },
    {
      name: "Fecha Consumo",
      selector: (row) => getFormattedDate(row.fechaConsumo.toString()),
      width: "8%",
    },
    {
      name: "Cantidad",
      selector: (row) => row.cantidad,
      width: "6%",
    },
    {
      name: "Valor",
      selector: (row) => getFormattedDecimal(row.precio),
      width: "8%",
    },
    {
      name: "Valor Total",
      selector: (row) => getFormattedDecimal(row.precio * row.cantidad),
      wrap: true,
      width: "8%",
    },
    {
      name: "Observacion",
      selector: (row) => row.observacion,
      wrap: true,
    },
    {
      name: "Estado",
      selector: (row) => row.estado,
      wrap: true,
      width: "8%",
    },
  ];

  const ArmarSerieNumero = (serie: string, numero: number) => {
    let serieNumero = "";
    if (serie != "") serieNumero = serie;

    if (serieNumero != "") {
      if (numero) {
        serieNumero = serieNumero + " - " + numero.toString();
      }
    } else {
      if (numero) {
        serieNumero = numero.toString();
      }
    }
    return serieNumero;
  };
  const authInfo = useSelector<RootState, UserInfo>(
    ({ auth }: any) => auth.info,
    shallowEqual
  );

  useEffect(() => {
    if (location.search === "") {
      setQueryParams(initialFilter);
    }
    if (queryParams.page && authInfo) {
      getPracticas();
    }
  }, [profesionalIdSelected, queryParams, authInfo]);

  useEffect(() => {
    if (authInfo) {
      if (authInfo.role === "ADMIN" && profesionales.length === 0) {
        getProfesionales("");
      }
    }
  }, [authInfo]);

  const getPracticas = async () => {
    setFetching(true);
      let params = { ...queryParams };
      if (profesionalIdSelected) {
        params = { ...params, profesionalId: profesionalIdSelected };
      }

      if (params.search || params.profesionalId) {
        setFetching(true);
        importacionSempreServices
          .getPrecargaAdminList(params)
          .then((response) => {
            setFetching(false);
            setEntities(response.data.items);
            setTotalCount(response.data.totalItems);
          })
          .catch((error) => {});
      }
      else {
        setEntities([]);
        setTotalCount(0);
      }
  };

  const getProfesionales = async (searchValue: string) => {
      setQueryParamsProfesional({
        ...initialProfesionalFilter,
        filter: searchValue,
      });
      profesionalServices
        .lookup(queryParamsProfesional)
        .then((response) => {
          const items: ListModel[] = [];
          response.data.forEach((element: any) => {
            items.push({
              value: element.id,
              label: element.value + " " + element.description,
            });
          });
          setProfesionales(items);
        })
        .catch((error) => {});
    };
    
  return (
    <div className="precarga-admin-list-container">
      <div className="row action-button">
        <AutocompleteSelect
            name="profesionalId"
            label="Profesional"
            isMultiple={false}
            options={profesionales}
            onChange={(value) => {
              setProfesionalIdSelected(value);
            }}
          ></AutocompleteSelect>
          <OutlinedInput
            type={"text"}
            placeholder="Búsqueda por nombre de afiliado, cuil o número de validación online"
            className={`custom-input`}
            autoComplete="off"
            onChange={(event) => {
              setQueryParams({
                ...queryParams,
                search:
                  event.target.value !== "" ? event.target.value : undefined,
              });
            }}
          ></OutlinedInput>
      </div>
      <div className="row">
        <div className="practicas-table">
          <Table
            table={{
              columns,
              data: entities,
              paginationTotalRows: totalCount,
              pointerOnHover: true,
              highlightOnHover: true,
            }}
            setQueryParams={setQueryParams}
            queryParams={queryParams}
            fixedHeader={true}
            fixedHeaderScrollHeight={true}
          ></Table>
        </div>
      </div>
    </div>
  );
}
